import App from "app";
import WAHighMapsMixin from "app/components/dashboard/visualization/charts/vectormap/mixins/vectormap-highmaps";
import "app/components/dashboard/visualization/charts/chart";

App.module("Chart.VectorMap", function (Chart, App, Backbone, Marionette, $, _) {
    Chart.View = App.Chart.Default.ChartView.extend({
        initialize: function () {
            _(this).extend(WAHighMapsMixin);
            App.Chart.Default.ChartView.prototype.initialize.apply(this, arguments);
        },
    });
});
